<template>
  <div>
    <answer-render ref="answer" :config="config">
      <div slot="head">
        <answer-desc-list
          :config="config"
          optionKey="optionName"
          optionValueKey="id"
          :answerValidate="answerValidate"
        ></answer-desc-list>
      </div>
    </answer-render>
  </div>
</template>

<script>
import answerValidate from './answerValidate'
export default {
  name: 'RadioBoxGroupAnswer',
  props: ['config'],
  data () {
    return {
      answerValidate
    }
  },
  components: {},
  watch: {},
  computed: {},
  methods: {},
  created () {},
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/editor/RadioBoxGroup/RadioBoxGroupAnswer.vue